<template>
  <v-row>
    <v-dialog v-model="dialogActive" persistent width="400">
      <v-card>
        <v-card-title>{{
          $t(
            "components.dialogs.unsavedContentWarningDialog.doYouReallyWantToLeave"
          )
        }}</v-card-title>
        <v-card-text class="mt-2">
          {{
            $t(
              "components.dialogs.unsavedContentWarningDialog.youHaveUnsavedChanges"
            )
          }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="onCancel()"
            data-cy="importServiceProtocolDialogCancelBtn"
            >{{ $t("components.dialogs.unsavedContentWarningDialog.cancel") }}
          </v-btn>
          <v-btn color="primary" text @click="onLeave()">{{
            $t("components.dialogs.unsavedContentWarningDialog.leave")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  props: ["dialog"],
  computed: {
    dialogActive() {
      return !!this.dialog.active;
    },
  },
  methods: {
    onLeave() {
      this.$emit("redirect", true);
    },
    onCancel() {
      this.$emit("redirect", false);
    },
  },
};
</script>
